module.exports = __webpack_public_path__ + "img/groups-application-requests-active.898b5a5.svg";